import React, { FC } from 'react'
import QRCode from 'qrcode.react'
import { FormNotificationComponent, Heading, Indent, Text, TextType, UITypes } from 'LibNeo'
import { orderEditSelectors, TYPE_SUBMIT_FORM } from 'Pages/registratorCabinet'
import { BtnComponent } from 'LibNeo/components'
import { Form } from 'antd'
import { shallowEqual, useSelector } from 'react-redux'
import { FormNames } from 'Constants/FormNames'
import { FormComponentProps } from 'antd/lib/form'
import { SECOND_LIMIT_CONFIRM } from 'Pages/ibro'
import { useFormConnector, useTimer } from 'Src/hooks'
import { PhoneInput } from 'LibNeo/containers/form'
import { ModalContent, ModalTimer } from './styled'

interface ComponentProps extends FormComponentProps {
	submitForm: (type: string, code?: string, need_sms?: boolean, isQrCodeForSbol?: boolean) => void
	isQrCodeForSbol: boolean
	need_sms: boolean
}

const PhoneConfirmationModal: FC<ComponentProps> = ({
	submitForm,
	form,
	isQrCodeForSbol,
	need_sms,
}) => {
	const order = useSelector(orderEditSelectors.getOne, shallowEqual)
	useFormConnector(FormNames.REGISTRATOR_CABINET.EMAIL_OR_PHONE_CONFIRMATION, form)

	const { timerSecond } = useTimer(order?.updated_at, SECOND_LIMIT_CONFIRM)

	const seconds = timerSecond % 60

	return (
		<>
			<Indent bottom={24}>
				<Indent bottom={4}>
					<Heading type="h5">Подтверждение Сбербанк Онлайн</Heading>
				</Indent>
			</Indent>

			<Indent bottom={24}>
				<PhoneInput label="Номер телефона" form={form} initialValue={order.phone} disabled />
			</Indent>

			<FormNotificationComponent
				hideIcon
				message={
					isQrCodeForSbol
						? `Отсканируйте QR-код с помощью камеры телефона, перейдите по ссылке и подтвердите Сбербанк Онлайн.`
						: 'На телефон, который указан в заявке, придёт сообщение со ссылкой. ' +
						  'Перейдите по ней и подтвердите Сбербанк Онлайн.'
				}
				type={UITypes.INFO}
			/>

			{isQrCodeForSbol && order?.authentication_link && (
				<Indent top={24}>
					<ModalContent>
						<QRCode size={148} value={order.authentication_link} />
					</ModalContent>
				</Indent>
			)}

			<Indent top={24}>
				{order && (
					<ModalTimer>
						<BtnComponent
							disabled={timerSecond > 0}
							outline={isQrCodeForSbol}
							type={UITypes.PRIMARY}
							title={isQrCodeForSbol ? 'Обновить QR-код' : 'Отправить СМС'}
							onClick={() =>
								submitForm(
									TYPE_SUBMIT_FORM.SEND_CODE_EMAIL_OR_PHONE_AGAIN,
									null,
									need_sms,
									isQrCodeForSbol
								)
							}
						/>
						{timerSecond > 0 && (
							<Text type={TextType.CAPTION} colorIndex={5}>
								{isQrCodeForSbol ? 'Обновить код' : 'Отправить повторно'} можно через{' '}
								{(timerSecond - seconds) / 60}:{seconds > 9 ? seconds : `0${seconds}`}
							</Text>
						)}
					</ModalTimer>
				)}
			</Indent>
		</>
	)
}

export const PhoneConfirmationModalComponent = Form.create({
	name: FormNames.REGISTRATOR_CABINET.EMAIL_OR_PHONE_CONFIRMATION,
})(PhoneConfirmationModal)
